<template>
  <div id="lcly-button-0">
    <a id="lcly-link-0" href="https://brands.locally.com" target="_blank">Powered by Locally</a>
  </div>
</template>

<script>
import {Url} from '@/utils/url';

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    locallyConfig() {
      return {
        store: this.options.locally.store,
        uri: 'search',
        sort: 'price-high-to-low',
      };
    },
    locallyQuery() {
      return Url.objectToQueryStringArray(this.locallyConfig).join('&');
    },
  },
  mounted() {
    this.appendLocallyScript();
  },
  methods: {
    appendLocallyScript() {
      const script = document.createElement('script');
      script.src = `${this.options.locally.baseUrl}/widgets/search.js?${this.locallyQuery}`;
      document.head.appendChild(script);
    },
  },
};
</script>
